import { Container, ContentBox } from '../../styles/chime-react/CommonStyles';

// liff以外から開かれた時に出るエラー画面
const NotLineBrowserError = () => {
  return (
    <Container maxWidth="49rem" alignMiddle>
      <ContentBox padding="1.5rem 1rem">
        SafariやChromeなどの標準ブラウザでは表示できません。
        <br />
        設定をご確認いただき、LINEアプリ内からご覧ください。
      </ContentBox>
    </Container>
  );
};

export default NotLineBrowserError;
